export const productionColors = [
  "#ED911B",
  "#AD64C5",
  "#18713D",
  "#1789D5",
  "#2F1C91",
  "#48233C",
  "#244A92",
  "#E76830",
  "#008DA3",
  "#AB2962",
  "#75512A",
  "#B00105",
  "#4C4F53",
  "#6830E6",
  "#CBE18F",
  "#082144",
  "#EA5267",
  "#CDAF4E",
  "#575D51",
  "#5AA58F",
];
